import { render, staticRenderFns } from "./TextWidget.vue?vue&type=template&id=574f99fe&"
import script from "./TextWidget.vue?vue&type=script&lang=js&"
export * from "./TextWidget.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\escal\\Projects\\Betterway.Vms\\Betterway.VMS.web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('574f99fe')) {
      api.createRecord('574f99fe', component.options)
    } else {
      api.reload('574f99fe', component.options)
    }
    module.hot.accept("./TextWidget.vue?vue&type=template&id=574f99fe&", function () {
      api.rerender('574f99fe', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Widgets/TextWidget.vue"
export default component.exports